import { render, staticRenderFns } from "./MyNeighbourhood.vue?vue&type=template&id=ff8c91e4&scoped=true&"
import script from "./MyNeighbourhood.vue?vue&type=script&lang=ts&"
export * from "./MyNeighbourhood.vue?vue&type=script&lang=ts&"
import style0 from "./MyNeighbourhood.vue?vue&type=style&index=0&id=ff8c91e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c91e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VList,VListItem,VListItemContent,VListItemTitle,VSubheader})
